import { inject } from '@angular/core';
import { Location } from '@angular/common';
import { InstrumentationService } from 'app/common/services/instrumentation.service';

// Base page component for all other page components. Adds common functionality, such as instrumentation,
// that will run when any page is visited. Other common page functionality can be placed here too.
export abstract class BasePageComponent {
    private instrumentationService = inject(InstrumentationService);
    private location = inject(Location);

    // BasePageComponent constructor.
    constructor() {
        // inject() function retrieves services without needing them passed from child components
        this.instrumentationService.trackPageView(this.location.path(), null /* AI will use the full current URL here */, { referrer: document.referrer }, null, null);
    }
}
